module.exports = __webpack_public_path__ + "img/leverages-marker.c1254706.svg";